import { useEffect, useRef, useState } from 'react';
import { useTranslations } from '@omnipkg/ui-kit-web';

import { useTranslate } from '../../hooks/useTranslate';
import { getDir } from '../../utils/getDir';
import WorkSchedule from './components/WorkSchedule';
import { useGetWorkingData } from './hooks/useGetWorkingData';
import { WorkingHoursProps } from './types';

import {
  ChevronIcon,
  ClosesValue,
  ScheduleButton,
  StatusValue,
  WorkingDataContainer,
  WorkingInfoContainer,
  WorkingInfoIconWrapper,
  WorkScheduleContainer,
} from './styled';

export default function WorkingHours({ icon }: WorkingHoursProps): JSX.Element {
  const [isOpen, setIsOpen] = useState(false);
  const [listHeight, setListHeight] = useState(0);
  const list = useRef<HTMLUListElement>(null);

  const { langData } = useTranslations();
  const { closes, day, isAvailable, statusValue, workSchedule } =
    useGetWorkingData();
  const dir = getDir();

  const { staticTranslate } = useTranslate();

  function toggleVisibility(): void {
    setIsOpen((s) => !s);
  }

  useEffect(() => {
    if (!list.current) return;
    setListHeight(list.current.getBoundingClientRect().height);
  }, [list, workSchedule]);

  const closesValue = langData.lang === 'he' ? `${day}-${closes}` : closes;

  return (
    <WorkingDataContainer aria-label="Device work schedule">
      <WorkingInfoIconWrapper>
        {icon}
        <WorkingInfoContainer>
          <StatusValue
            isActive={isAvailable}
            aria-label="Device working status"
          >
            {statusValue}
          </StatusValue>
          <ScheduleButton
            onClick={toggleVisibility}
            aria-label="Show device work schedule"
          >
            <ClosesValue>
              {staticTranslate('closes')} {closesValue}
            </ClosesValue>
            <ChevronIcon dir={dir} isOpen={isOpen} />
          </ScheduleButton>
        </WorkingInfoContainer>
      </WorkingInfoIconWrapper>
      <WorkScheduleContainer height={listHeight} isOpen={isOpen}>
        <WorkSchedule ref={list} workSchedule={workSchedule} />
      </WorkScheduleContainer>
    </WorkingDataContainer>
  );
}
